import jQuery from "jQuery";
import UnityLoader from "UnityLoader";
import * as facebook from "./facebook";
import * as unity from "./unity";
import * as common from "./common";

/*global googletag*/
/*global Sibbo*/

/** @namespace adsData.campaingOnNoAds */
/** @namespace adsData.loaded */
/** @namespace adsData.sound */
/** @namespace adsData.timeToClose */

let closeTimer = null;
let adsData = null;
let adsOnClose = null;
let adsCustomData = null;
let adsCampaign = null;
let countdownInterval = null;

const topAds = "div-gpt-ad-1437070121632-0";
const footerAds = "div-gpt-ad-1437070285323-0";

export function isOpen() {
    return jQuery("#ads").css("display") !== "none";
}

export function getCampaign() {
    return adsCampaign;
}

export function isForcePubli() {
    return typeof common.config !== "undefined" && common.config !== null && common.config.psForcePubli;
}

export function isShowPubli() {
    // TODO - fbisquerra: Disable ads until a decision is made regarding the ads performance in wasm
    // return typeof common.loginData !== "undefined" && common.loginData !== null && common.loginData.showPubli;
    return false;
}

export function isShowAds() {
    return isShowPubli() || isForcePubli();
}

export function getFooterAdsHeigh(){
    return document.getElementById(footerAds).clientHeight;
}

function segmentation() {
    let gender = (typeof common.loginData.gender !== "undefined" ? common.loginData.gender : "UNDEFINED").toLowerCase();
    let age = -1;

    if (typeof common.loginData.birthday !== "undefined") {
        age = new Date().getFullYear() - parseInt(common.loginData.birthday.split("/")[2]);
    }

    let code = 0;

    if (age > 0 && age <= 14) {
        if (gender === "female") code = 7;
        else if (gender === "male") code = 5;
        else code = 15;
    } else if (age >= 15 && age <= 17) {
        if (gender === "female") code = 1;
        else if (gender === "male") code = 4;
        else code = 16;
    } else if (age >= 18 && age <= 24) {
        if (gender === "female") code = 14;
        else if (gender === "male") code = 11;
        else code = 17;
    } else if (age >= 25 && age <= 34) {
        if (gender === "female") code = 6;
        else if (gender === "male") code = 3;
        else code = 18;
    } else if (age >= 35 && age <= 44) {
        if (gender === "female") code = 2;
        else if (gender === "male") code = 8;
        else code = 19;
    } else if (age >= 45 && age <= 54) {
        if (gender === "female") code = 10;
        else if (gender === "male") code = 9;
        else code = 20;
    } else if (age >= 55) {
        if (gender === "female") code = 13;
        else if (gender === "male") code = 12;
        else code = 21;
    } else {
        if (gender === "female") code = 22;
        else if (gender === "male") code = 23;
        else code = 0;
    }

    return code;
}

function open(campaign, onClose, customData) {

    if (!isShowAds() || isOpen()) {
        return;
    }

    close();

    let adUrl = common.config.baseUrl + "adss.jsp?";
    let psgroup = segmentation();

    adUrl += "locale=" + common.loginData.locale;
    adUrl += "&new=" + common.loginData.newUser;
    adUrl += "&gameName=" + common.config.gameName;
    adUrl += "&country=" + common.config.country;

    if (typeof common.loginData.birthday !== "undefined") {
        adUrl += "&psgroup=" + psgroup;
    }
    if (typeof campaign !== "undefined") {
        adUrl += "&campaign=" + campaign;
        adsCampaign = campaign;
    }
    if (typeof common.config.platformData.psAffiliate !== "undefined") {
        adUrl += "&psAffiliate=" + common.config.platformData.psAffiliate;
    }
    if (typeof common.config.platformData.psAffiliateBusiness !== "undefined") {
        adUrl += "&psAffiliateBusiness=" + common.config.platformData.psAffiliateBusiness;
    }
    if (typeof common.config.environment === "string") {
        adUrl += "&psEnvironment=" + common.config.environment;
    }

    let adsDiv = jQuery("#ads");
    let iframe = jQuery(`<iframe id="adsFrame" src="${adUrl}" style="overflow: hidden; margin: 0; padding: 0; border: none;" frameborder="0" scrolling="no"/>`).show();
    adsDiv.find(".popup-ads-content").append(iframe);
    adsDiv.show().css("top", "-10000px");

    if (typeof onClose !== "undefined") {
        adsOnClose = onClose;
    }
    if (typeof customData !== "undefined") {
        adsCustomData = customData;
    }

    jQuery(iframe).on("load", function () {

        adsData = this.contentWindow["adsData"];
        if (typeof adsData === "undefined") {
            adsData = null;
            close();
            return;
        }

        this.contentWindow["closeAds"] = close;
        this.contentWindow["onAdsReady"] = onReady;
        this.contentWindow["customData"] = adsCustomData;

        if (typeof adsData.loaded === "undefined" || adsData.loaded) {
            onReady(adsData);
        }
    });
}

function onReady(adsDataIframe) {
    adsData = adsDataIframe;

    if (typeof adsData === "undefined" || adsData === null) {
        close();
        return;
    }

    if (typeof adsData.loaded !== "undefined" && !adsData.loaded) {
        return;
    }

    if (typeof adsData.show !== "undefined" && !adsData.show) {
        close();
        return;
    }

    if (typeof adsData.sound !== "undefined" && !adsData.sound) {
        unity.mute();
    }

    let flashPosition = jQuery(unity.getCanvas()).position();

    jQuery("#adsFrame")
        .attr("width", adsData.frame.width)
        .attr("height", adsData.frame.height);

    let adsDiv = jQuery("#ads");

    adsDiv.find(".popup-ads-content")
        .css("width", adsData.frame.width)
        .css("height", adsData.frame.height);

    adsDiv.find(".popup-ads")
        .css("width", adsData.frame.width + 40);

    let marginLeft = -1 * adsData.background.width / 2;
    if (typeof adsData.background.right !== "undefined") {

        let swfHeight = UnityLoader.SystemInfo.height; // Alto por defecto

        marginLeft -= (unity.getCanvas().height * adsData.background.right) / swfHeight;
    }

    jQuery(".popup-ads-closebtn").hide();
    adsDiv.show()
        .css("left", "50%")
        .css("margin-left", marginLeft)
        .css("top", flashPosition.top + adsData.background.top);

    if (typeof adsData.background.modal === "boolean" && adsData.background.modal) {

        adsDiv.parent()
            .css("width", "100%")
            .css("height", "100%")
            .css("position", "fixed")
            .css("z-index", "999")
            .css("background-color", "rgba(0,0,0,0.7)")
            .css("top", "0px");
    } else {

        adsDiv.parent()
            .css("width", "")
            .css("height", "")
            .css("position", "")
            .css("z-index", "")
            .css("background-color", "")
            .css("top", "");
    }

    //Enviamos a analytics los eventos de click
    if (typeof adsData.url !== "undefined") {
        jQuery("#adsblank").attr("href", adsData.url).show();
    }

    if (typeof adsData.duration !== "undefined") {
        closeTimer = setTimeout(close, adsData.duration);
    }

    if (typeof adsData.timeToClose !== "undefined") {

        let countdownCounter = adsData.timeToClose / 1000;

        jQuery("#popup-ads-countdown").text(countdownCounter);
        jQuery("#popup-ads-countdown-message").show();

        countdownInterval = window.setInterval(function () {
            jQuery("#popup-ads-countdown").text(--countdownCounter);
            if (countdownCounter <= 0 && typeof countdownInterval !== "undefined") {
                jQuery("#popup-ads-countdown-message").hide();
                window.clearInterval(countdownInterval);
                countdownInterval = null;
            }
        }, 1000);

        if (typeof adsData.internalClose === "undefined" || !adsData.internalClose) {
            setTimeout(function () {
                jQuery(".popup-ads-closebtn").show();
            }, adsData.timeToClose);
        }
    } else {
        jQuery("#popup-ads-countdown-message").hide();
    }
}


function close(fromButton) {

    if (closeTimer !== null) {
        clearInterval(closeTimer);
    }

    if (countdownInterval !== null) {
        clearInterval(countdownInterval);
    }

    if (typeof fromButton !== "undefined" && fromButton && adsOnClose !== null) {
        adsOnClose();
    }

    unity.unmute();

    let prevOnClose = adsOnClose;
    let prevAdsData = adsData;
    let prevCustomData = adsCustomData;
    adsOnClose = null;
    adsCampaign = null;
    adsData = null;
    adsCustomData = null;


    jQuery("#adsFrame").remove();
    jQuery("#ads")
        .hide()
        .parent()
        .css("width", "")
        .css("height", "")
        .css("position", "")
        .css("z-index", "")
        .css("background-color", "");

    if (prevAdsData !== null &&
        typeof prevAdsData.show !== "undefined" &&
        !prevAdsData.show &&
        typeof prevAdsData.campaingOnNoAds !== "undefined") {

        open(prevAdsData.campaingOnNoAds, prevOnClose, prevCustomData);
    }
}

export function openSlider(top, orientation, format) {

    let flashPosition = jQuery(unity.getCanvas()).position();
    let elementById = document.getElementById("intextCont");

    if (elementById !== null) {
        closeSlider();
    }

    //closeSliderTimer = setTimeout(closeSlider, 10000);

    common.loadScript("//adsby.adscidad.net/ad/adfp/77342/?t=" + (flashPosition.top + top) + "&o=" + orientation + "&f=" + format + "&r=" + +new Date().getTime(), function () {

    });
}

function closeSlider() {

    let elementById = document.getElementById("intextCont");

    if (elementById !== null)
        elementById.parentNode.removeChild(elementById);
}

export function isSliderOpen() {
    let elementById = document.getElementById("intextCont");
    return elementById !== null;
}


export function isBannerAds() {

    let topAdsDiv = jQuery("#" + topAds);
    let footerAdsDiv = jQuery("#" + footerAds);

    return isShowAds() && (topAdsDiv.length > 0 || footerAdsDiv > 0);
}

function refreshSlot(slot) {
    if (typeof Sibbo !== "undefined") Sibbo.refreshSlot([slot]);
    else googletag.pubads().refresh([slot]);
}

export function init() {

    // google tags
    common.onLoginData(() => {
        googletag.cmd.push(function () {

            if (common.loginData === null) {
                return;
            }

            if (typeof window.__tcfapi === "function") {
                window.__tcfapi("getOtherVendorConsents", 2, (otherVendorConsents, success) => {
                    if (success && otherVendorConsents.googleConsent === "1") {
                        googletag.pubads().setRequestNonPersonalizedAds(0);
                    } else {
                        googletag.pubads().setRequestNonPersonalizedAds(1);
                    }
                });
            } else {
                googletag.pubads().setRequestNonPersonalizedAds(1);
            }

            let t = [0, 0.7, 1.2, 1.7, 2.2][(Math.floor(Math.random() * 5))].toString();
            let psgroup = segmentation();
            let scheme = "https";

            window.gKeywords = "psgroup=" + psgroup + "&scheme=" + scheme;
            window.adKeyword = "psgroup=" + psgroup + ";gCat=" + psgroup + ";gName=" + common.config.gameName + ";scheme=" + scheme + ";";

            googletag.pubads().setTargeting("T", t.toString());
            googletag.pubads().setTargeting("psgroup", psgroup);
            googletag.pubads().setTargeting("game", common.config.gameName);
            googletag.pubads().setTargeting("scheme", scheme);

            if (typeof common.config.platformData.psAffiliate !== "undefined") {
                googletag.pubads().setTargeting("affiliate", common.config.platformData.psAffiliate);
                window.gKeywords += "&affiliate=" + common.config.platformData.psAffiliate;
                window.adKeyword += "affiliate=" + common.config.platformData.psAffiliate + ";";
            }

            if (typeof common.config.platformData.psAffiliateBusiness !== "undefined") {
                googletag.pubads().setTargeting("afbusiness", common.config.platformData.psAffiliateBusiness);
                window.gKeywords += "&afbusiness=" + common.config.platformData.psAffiliateBusiness;
                window.adKeyword += "afbusiness=" + common.config.platformData.psAffiliateBusiness + ";";
            }

            if (typeof common.config.environment === "string") {
                googletag.pubads().setTargeting("env", common.config.environment);

                window.gKeywords += "&env=" + common.config.environment;
                window.adKeyword += "env=" + common.config.environment + ";";

                if (common.config.environment.toLocaleLowerCase() !== "facebook") {
                    googletag.pubads().setTargeting("gCampaign", "noSkin");
                    window.adKeyword += "gCampaign=noSkin;";
                }
            }

            if (facebook.isCanvas()) {
                googletag.pubads().setTargeting("gCampaign", "noSkin");
                window.adKeyword += "gCampaign=noSkin;";
            }

            window.adKeyword += "gCustom=" + encodeURIComponent(encodeURIComponent(window.gKeywords)) + ";";

            if (!isShowAds()) return;

            let topAdsDiv = jQuery("#" + topAds);
            let footerAdsDiv = jQuery("#" + footerAds);

            if (topAdsDiv.length > 0) {
                let slot1 = googletag.defineSlot("/139582134/Billboard_superior_Skin", [[728, 90], [970, 90], [1000, 250], [970, 250], [980, 250]], topAds);
                slot1.addService(googletag.pubads());
                slot1.setCollapseEmptyDiv(true, true);

                setInterval(function () {
                    refreshSlot(slot1);
                }, 75000);
            }

            if (footerAdsDiv.length > 0) {
                let slot2 = googletag.defineSlot("/139582134/Billboard_inferior", [[728, 90], [970, 90], [1000, 250], [970, 250], [980, 250]], footerAds);
                slot2.addService(googletag.pubads());
                slot2.setCollapseEmptyDiv(true, true);

                setInterval(function () {
                    refreshSlot(slot2);
                }, 75000);
            }

            if (footerAdsDiv.length > 0 || topAdsDiv.length > 0) {
                googletag.pubads().enableSingleRequest();
                googletag.pubads().collapseEmptyDivs();
                googletag.enableServices();
            }

            if (topAdsDiv.length > 0) {
                googletag.cmd.push(function () {
                    googletag.display(topAds);
                });
            }
            if (footerAdsDiv.length > 0) {
                googletag.cmd.push(function () {
                    googletag.display(footerAds);
                });
            }

            if (t !== "0" && typeof Sibbo !== "undefined") Sibbo.start(t);
        });
    });
}

//
// let idleTime = 0;
// let idleInterval = null;
// let publiLaunchIdle = 8;
// let publiLaunchActivity = 5;
//
// jQuery(document).ready(function () {
//
//     //Zero the idle timer on mouse movement.
//     $(this).mousemove(function (e) {
//         idleTime = 0;
//     });
//     $(this).keypress(function (e) {
//         idleTime = 0;
//     });
// });
//
// let isInReloadGames = false;
// let isInGame = false;
// let isBigChat = false;
// let isPopUp = false;
// let lobbyPubliInterval = null;
//
// function isValidStateToOpenPubli() {
//     return !isPopUp && !isInGame && !expandedSPD;
// }
//
// function checkGameStatus() {
//
//     if (!PS.publi.isShowPubli()) return;
//
//     if (PS.publi.isOpen() || PS.publi.isSliderOpen() || PS.videos.isVideoOpened())  {
//
//         if (isPopUp || isInGame) {
//             closeAllPubliTimers()
//         }
//     }
//     else {
//
//         if (isValidStateToOpenPubli()) {
//
//             if (typeof idleInterval !== "number") {
//
//                 idleTime = 0;
//                 idleInterval = setInterval(timerIncrement, 1000);
//             }
//
//             if (typeof lobbyPubliInterval !== "number") {
//                 setLobbyPubliInterval()
//             }
//         }
//     }
// }
//
// function setLobbyPubliInterval() {
//
//     window.clearInterval(lobbyPubliInterval);
//
//     PS.publi.closeSlider();
//
//     lobbyPubliInterval = window.setInterval(function() {
//
//         if (isValidStateToOpenPubli()) {
//
//             if (!PS.publi.isSliderOpen() && !PS.publi.isOpen()&& !PS.videos.isVideoOpened() && (idleTime * 100) < 80) {
//                 PS.publi.openSlider(80, 0, 1);
//                 idleTime = 0;
//             }
//         }
//         else {
//             closeAllPubliTimers();
//         }
//
//     }, publiLaunchActivity * 1000);
// }
//
// function timerIncrement() {
//     idleTime = idleTime + 1;
//     if (idleTime >= publiLaunchIdle) { // 20 minutes
//
//         idleTime = 0;
//
//         if (isValidStateToOpenPubli()) {
//
//             if (!PS.publi.isSliderOpen() && !PS.publi.isOpen() && !PS.videos.isVideoOpened()) {
//
//                 setLobbyPubliInterval();
//                 PS.publi.open('LobbyReloadGames', function() {});
//             }
//         }
//         else {
//             closeAllPubliTimers();
//         }
//     }
// }
//
// function closeAllPubliTimers() {
//
//     if (isInGame || PS.publi.getCampaing() == null || PS.publi.getCampaing().indexOf('LobbyReloadGames') >= 0)
//         PS.publi.close();
//
//     PS.publi.closeSlider();
//
//     if (idleInterval !== null) {
//         window.clearInterval(idleInterval);
//         idleInterval = null;
//     }
//
//     if (lobbyPubliInterval != null) {
//         window.clearInterval(lobbyPubliInterval);
//         lobbyPubliInterval = null;
//     }
// }
//
// $(document).ready(function() {
//
//     PS.event.subscribe(PS.event.EVENT_LOBBY_RELOAD_GAMES, function(event, isReload) {
//         isInReloadGames = isReload;
//         checkGameStatus();
//     });
//
//     PS.event.subscribe(PS.event.EVENT_BIGCHAT, function(event, open) {
//
//         isBigChat = open;
// //            checkGameStatus();
//     });
//
//     PS.event.subscribe(PS.event.EVENT_POPUP, function(event, name, open) {
//
//         isPopUp = open;
//         checkGameStatus();
//     });
//
//     PS.event.subscribe(PS.event.EVENT_JOIN_ROOM, function(event, isGame) {
//
//         isInReloadGames = false;
//         isInGame = isGame;
//         checkGameStatus();
//     });
//
//     $(document).on("keydown", function(e) {
//         if(e.which === 120) {
//             PS.publi.close();
//             PS.publi.closeSlider();
//         }
//     });
//
// });